import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
const Category = () => {

  const { id } = useParams(); // Get category ID from URL
  const [products, setProducts] = useState([]);
  useEffect(() => {
    fetch(`https://leapatinternational.com/admin/api/v1/web_category_list.php`)
      .then((response) => response.json())
      .then((data) => setProducts(data.data))
      .catch((error) => console.error("Error fetching products:", error));
  }, [id]);

  return (
    <div>
      <div class="container category_container">
        <h2 class="title">Category</h2>
        <div class="grid">
          {products?.map((product) => (
            <div className="grid-item mx-2" key={product.id}>
              <Link to={`/product-category/${product.id}`}>
                <img src={product.image} alt={product.product_name} />
              </Link>
              <p>{product.title}</p>
            </div>
          ))}
        </div>
      </div>


      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
        <i className="bi bi-arrow-up"></i>
      </a>


      {/* Optional: Add any other content or components here */}

      <style>
        {`
                /* Add your custom CSS here */
                .service-item-top {
                  transition: transform 0.3s ease-in-out;
                }
        
                .service-item-top:hover {
                  transform: scale(1.05);
                }
             .title {
    font-size: 24px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 20px;
}
.grid-item img{
display: block;
  height: 300px;
  overflow: hidden;
  width: 100%;}
.grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
}
.category_container{margin-top:135px}
.grid-item {
    width: calc(23.333% - 10px);
    background: white;
    border-radius: 5px;
    overflow: hidden;
    text-align: center;
}



.grid-item p {
    margin: 10px 0;
    font-weight: bold;
    font-size: 14px;
}

/* Responsive Styles */
@media (max-width: 900px) {
    .grid-item {
        width: calc(50% - 10px);
    }
}

@media (max-width: 600px) {
    .grid-item {
        width: 100%;
    }
}
                /* Add any additional styling you want */
              `}
      </style>
    </div>
  );
};

export default Category;
